export default __webpack_public_path__ + "static/media/Abyssal Shroud.764c2f5d.jpg";